/**
 * Development Logger Utility
 * Provides logging functions that only output in development environment
 */

export const devLog = {
  log: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  },
  
  warn: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(...args);
    }
  },
  
  error: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.error(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      console.debug(...args);
    }
  },

  // Production-safe logging (always shows, but with prefix)
  production: {
    log: (...args: any[]) => console.log('[PROD]', ...args),
    warn: (...args: any[]) => console.warn('[PROD]', ...args),
    error: (...args: any[]) => console.error('[PROD]', ...args),
  }
};

export default devLog;